import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1)
const _hoisted_2 = { class: "ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EmbededErrorComponent = _resolveComponent("EmbededErrorComponent")!

  return (_openBlock(), _createBlock(_component_EmbededErrorComponent, null, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$beautify.firstLetterUppercase(
					_ctx.$text('expressions', 'Error_No_Brand_Found_Title')
				)), 1)
    ]),
    button: _withCtx(() => [
      _createVNode(_component_router_link, {
        class: "btn btn-brand mt-10",
        to: {
					name: _ctx.$config('RouteConfig', 'BrandCreateRouteName'),
					params: _ctx.$route.params,
				}
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$beautify.firstLetterUppercase(_ctx.$text('actions', 'Create_First_Brand'))), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _: 1
  }))
}